import { render, staticRenderFns } from "./ProceduresList.vue?vue&type=template&id=8346782e&scoped=true&lang=pug"
import script from "./ProceduresList.vue?vue&type=script&lang=js"
export * from "./ProceduresList.vue?vue&type=script&lang=js"
import style0 from "./ProceduresList.vue?vue&type=style&index=0&id=8346782e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8346782e",
  null
  
)

export default component.exports